import * as Api from '../../utils/request'


export default {
	
	/**
	 * 获取首页列表页数据
	 * @returns {Promise.<*>}
	 */

	//指数板块
	async getList(){
		return await Api.get({
			url:'/H5ReactIndex/indexPlate',
			params:{}
		})
	},
	//要闻列表板块置顶
	async getImportantNewsList1(){
		return await Api.get({
			url:'/H5ReactIndex/hotExpress'
		})
	},
	//要闻列表板块非置顶
	async getImportantNewsList2(before){
		return await Api.get({
			url:'/H5ReactExpress/index',
			params:{
				before
			}
		})
	},
	//要闻详情板块
	async getImportNewsDetail(id){
		return await Api.get({
			// url:'mobile//H5ReactExpress/detail',
			url:'/H5ReactExpress/detail',
			params:{
				id
			}
		})
	},
	//获取评论列表，要闻，专栏，直播中的精彩评论
	async getComment(id, kind ){
		return await Api.get({
			url:'/H5ReactExpress/comment',
			params:{
				id,
				kind
			}
		})
	},
	//获取专栏详情页精彩推荐
	async getGoodRecommend(){
		return await Api.get({
			url:'/H5ReactNews/goodRecommend',
			params:{
			}
		})
	},
		//分享功能所需数据接口
  async getShare(){
		return await Api.get({
			url:'/H5ReactLives/wechatSharingLink',
			params:{}
		})
  },
}
